import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) => ({
    addProjectButton: {
        borderRadius: 100,
        color: theme.palette.common.white,
        fontWeight: 'normal',
        textTransform: 'capitalize',
    },
    titleBarCont: {
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    addProject: {
        marginRight: theme.spacing(1),
        margin: 'auto',
    },
    projectTitleCont: {
        marginLeft: 0,
        margin: 'auto',
        padding: '6px 0px',
        fontSize: pxToRem(16),
    },
}))

interface ProjectTitleBarProps {
    projectTitle: string
    onAddClick: VoidFunction
    addProjectButton: boolean
}
const ProjectTitleBar: React.FC<ProjectTitleBarProps> = ({
    projectTitle,
    onAddClick,
    addProjectButton,
}) => {
    const classes = useStyles()
    return (
        <GridContainer direction="row" className={classes.titleBarCont}>
            <GridItem className={classes.projectTitleCont}>
                {projectTitle}
            </GridItem>
            {addProjectButton && (
                <GridItem className={classes.addProject}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.addProjectButton}
                        onClick={onAddClick}
                        data-testid="btnAddNewProject"
                    >
                        Add New Project
                    </Button>
                </GridItem>
            )}
        </GridContainer>
    )
}

export default ProjectTitleBar
